// extracted by mini-css-extract-plugin
module.exports = {"content":"card_content__WQ3Qw","card_text":"card_card_text__h09iO"};